<template>
  <section class="admin-module-pending" data-testid="admin-module-pending">
    <p class="admin-module-pending__eyebrow">{{ t('admin.pending.eyebrow') }}</p>
    <h1>{{ title }}</h1>
    <p>{{ t('admin.pending.description') }}</p>
    <RouterLink to="/admin/dashboard">{{ t('admin.pending.back') }}</RouterLink>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

const route = useRoute()
const { t } = useI18n()
const title = computed(() => String(route.meta.title || t('admin.pending.title')))
</script>

<style scoped>
.admin-module-pending {
  max-width: 720px;
  padding: 32px;
  border: 1px solid var(--admin-color-border);
  border-radius: 12px;
  background: var(--admin-color-surface);
}

.admin-module-pending h1 {
  margin: 8px 0 16px;
  color: var(--admin-color-heading);
}

.admin-module-pending p {
  color: var(--admin-color-text-secondary);
  line-height: 1.7;
}

.admin-module-pending__eyebrow {
  margin: 0;
  color: var(--admin-color-primary) !important;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
</style>
